import type { IconRootProps } from './Root'
import { IconRoot } from './Root'

export const ChevronIcon = ({ size = '1.5rem', ...props }: IconRootProps) => (
  <IconRoot viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" size={size} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.506124 4.93557C0.817852 4.66281 1.29167 4.69439 1.56444 5.00612L5.55413 9.56577C6.26994 10.3838 6.75572 10.9363 7.17035 11.2943C7.56886 11.6384 7.80172 11.7128 8 11.7128C8.19828 11.7128 8.43114 11.6384 8.82966 11.2943C9.24429 10.9363 9.73007 10.3838 10.4459 9.56577L14.4356 5.00612C14.7083 4.69439 15.1822 4.66281 15.4939 4.93557C15.8056 5.20833 15.8372 5.68215 15.5644 5.99388L11.5378 10.5957C10.8684 11.3608 10.3139 11.9946 9.80992 12.4297C9.28063 12.8867 8.70926 13.2128 8 13.2128C7.29075 13.2128 6.71938 12.8867 6.19008 12.4297C5.68613 11.9946 5.13162 11.3608 4.46214 10.5957L0.43557 5.99388C0.162809 5.68215 0.194397 5.20833 0.506124 4.93557Z"
    />
  </IconRoot>
)
